/** @jsxImportSource @emotion/react */
import PropTypes from 'prop-types';
import { useMemo } from 'react';

import { EMPTY_STRING } from '../../const';
import Button from '../Button';
import ExternalLink from '../ExternalLink'
import Map from '../MapPageService';
import Text from '../Text';
import useStyles from './styles';

const LocationDetailsMap = ({
  contact,
  contactAddress,
  title,
  titleHeader,
  subTitle,
  locationDetails,
  sourceLoction,
  onClick,
  centername,
  isVenueLocation = false,
  providerName,
  ...rest
}) => {
  const styles = useStyles();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const locationDetailsObject = useMemo(
    () => [locationDetails],
    [locationDetails]
  );

  return (
    <div css={styles.base} className="contactMap">
      {locationDetails && (
        <div css={styles.locationDetailsWrapper}>
          <Text css={styles.sectionTitle} as="h3" size="6">
            {providerName
              ? providerName
              : centername
              ? centername.toLowerCase()
              : title?.toLowerCase()}{' '}
            location
          </Text>
          <Button.Link
            css={styles.link}
            aria-label="click here to redirect to bing map"
            to={`https://bing.com/maps?Rtp=pos${
              sourceLoction
                ? '.' + sourceLoction.latitude + '_' + sourceLoction.longitude
                : EMPTY_STRING
            }~pos.${locationDetails?.latitude}_${locationDetails?.longitude}~`}
            isExternal
            {...rest}
          >
            <Map
              pushPins={locationDetailsObject}
              mapOptions={{ zoom: 2 }}
              css={styles.map}
            />
          </Button.Link>
          <div css={styles.addressStyles}>
            <div>
              <Text css={styles.address}>ADDRESS</Text>
              <Text css={styles.contactAddress}>{contactAddress}</Text>
            </div>
            <div>
              <ExternalLink
                href={`https://bing.com/maps?rtp=pos${sourceLoction
                    ? '.' +
                    sourceLoction.latitude +
                    '_' +
                    sourceLoction.longitude
                    : EMPTY_STRING
                  }~pos.${locationDetails?.latitude}_${locationDetails?.longitude
                  }~`}
                css={styles.maplink}
                target='_blank'
              >
                Open map in new window
              </ExternalLink>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

LocationDetailsMap.prototype = {
  contact: PropTypes.object,
  contactAddress: PropTypes.string,
  title: PropTypes.string,
  titleHeader: PropTypes.string,
  subTitle: PropTypes.string,
  locationDetails: PropTypes.object,
  sourceLoction: PropTypes.object,
  onClick: PropTypes.func,
  centername: PropTypes.string,
  isVenueLocation: PropTypes.bool,
  providerName: PropTypes.string,
};

export default LocationDetailsMap;